import { render, staticRenderFns } from "./temPergGajiBiasa.vue?vue&type=template&id=4a6afc9e&scoped=true&"
import script from "./temPergGajiBiasa.vue?vue&type=script&lang=js&"
export * from "./temPergGajiBiasa.vue?vue&type=script&lang=js&"
import style0 from "./temPergGajiBiasa.vue?vue&type=style&index=0&id=4a6afc9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6afc9e",
  null
  
)

export default component.exports